










































































































import LazyHydrate from 'vue-lazy-hydration';
import {
  SfAddToCart,
  SfButton,
  SfGallery,
  SfHeading,
  SfLoader,
  SfPrice,
  SfRating,
  SfAlert,
  SfLink
} from '@storefront-ui/vue';
import {
  ref,
  computed,
  defineComponent,
  PropType,
  toRef,
  useFetch,
  onMounted,
  useContext,
} from '@nuxtjs/composition-api';
import {
  getName as getProductName,
  getPrice as getProductPrice,
  getSlug as getProductSlug,
  getId as getProductId,
  getCategory as getProductCategory,
  getProductSku,
  getProductThumbnailImage
} from '~/modules/catalog/product/getters/productGetters';
import useWishlist from '~/modules/wishlist/composables/useWishlist';
/* import useComparelist from '~/modules/comparelist/composables/useComparelist'; */
import SvgImage from '~/components/General/SvgImage.vue';
import HTMLContent from '~/components/HTMLContent.vue';
import AddToWishlist from '~/components/AddToWishlist.vue';
/* import AddToCompare from '~/components/AddToCompare.vue'; */
import { useUser } from '~/modules/customer/composables/useUser';
import { Product } from '~/modules/catalog/product/types';
import { useCart } from '~/modules/checkout/composables/useCart';
import ProductTabs from '~/modules/catalog/product/components/tabs/ProductTabs.vue';
import { useProductGallery } from '~/modules/catalog/product/composables/useProductGallery';
import { TabsConfig, useProductTabs } from '~/modules/catalog/product/composables/useProductTabs';
import PriceAlert from '~/components/czar/productAlret/PriceAlert.vue';
import StockAlert from '~/components/czar/productAlret/StockAlert.vue';
import ProductInfo from '~/components/ProductDetailPage/ProductInfo.vue';
import ProductStatusInfo from '~/components/ProductDetailPage/ProductStatusInfo.vue';
import RebatePriceBox from '~/components/ProductDetailPage/RebatePriceBox.vue';
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import SynchronyAd from '~/components/SynchronyAd.vue';
import AmLabels from '~/components/AmLabels.vue';
import BottomBox from '~/components/ProductDetailPage/BottomBox.vue';

export default defineComponent({
  name: 'SimpleProduct',
  components: {
    HTMLContent,
    LazyHydrate,
    SfAddToCart,
    SfButton,
    SfGallery,
    SfHeading,
    SfLoader,
    SfPrice,
    SfLink,
    SfRating,
    SfAlert,
    AddToWishlist,
    /* AddToCompare, */
    SvgImage,
    ProductTabs,
    PriceAlert,
    StockAlert,
    ProductInfo,
    ProductStatusInfo,
    RebatePriceBox,
    LoadWhenVisible,
    RelatedProducts: () => import('~/modules/catalog/product/components/RelatedProducts.vue'),
    UpsellProducts: () => import('~/modules/catalog/product/components/UpsellProducts.vue'),
    SkeletonLoader,
    SynchronyAd,
    AmLabels,
    BottomBox
  },
  transition: 'fade',
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    isFetching: {
      type: Boolean,
      default: true,
    },
    routerDataRes: {
      type: Object,
      default: {}
    },
  },

  setup(props) {
    const context = useContext();
    // @ts-ignore
    const { imageProvider, magentoBaseUrl } = context.$vsf.$magento.config;
    const { isAuthenticated, user, register, login, loading, load: loadUser } = useUser();
    useFetch(async () => { if (user.value === null) { await loadUser(); } });
    const qty = ref(1);
    const productGallery_palceholder = ref([]);
    const product = toRef(props, 'product');
    const { addItem, error: cartError, loading: isCartLoading, canAddToCart, addedtocart_id: addedtocart_id } = useCart();
    const { productGallery, imageSizes } = useProductGallery(product);
    const { addOrRemoveItem, isInWishlist } = useWishlist();
    /* const { addOrRemoveItemToCompare, isInComparelist } = useComparelist(); */
    const { activeTab, setActiveTab, openNewReviewTab } = useProductTabs();
    const page_type = "product-detail";
    const productShortDescription = computed(() => props.product?.short_description?.html || '',);
    const productPrice = computed(() => getProductPrice(props.product).regular);
    const productSpecialPrice = computed(() => getProductPrice(props.product).special);
    const addToCartError = computed(() => cartError.value?.addItem?.message);
    
    if(productGallery.value.length < 1){
      productGallery_palceholder.value = [ 
      	{ 
      		"mobile": { "url": magentoBaseUrl+"/media/catalog/product/placeholder/default/big_image.jpg"},
      		"desktop": { "url": magentoBaseUrl+"/media/catalog/product/placeholder/default/big_image.jpg" }, 
      		"big": { "url": magentoBaseUrl+"/media/catalog/product/placeholder/default/big_image.jpg" }, 
      		"alt": getProductName(product.value), 
      		"placeholder": "", 
      		"videocontant": null 
      	} 
      ];
    }

    // inside setup()
    const firstImageUrl = computed(() => {
      const g = productGallery.value || [];
      const fromGallery = g.length > 0 ? (g[0]?.desktop?.url || g[0]?.mobile?.url || g[0]?.big?.url || null) : null;
      const fromThumb = (props.product as any)?.thumbnail?.url || (props.product as any)?.small_image?.url || null;
      return fromGallery || fromThumb;
    });

    onMounted(() => {
      if (process.client) {
        // @ts-ignore
        if (Extend) {
          setTimeout(function () {
            // @ts-ignore
            Extend.buttons.render('#extend-offer', {
              referenceId: product.value.sku, 
              storeId: 'cb9140a0-e99c-4755-ae3f-1a09b470b8ea',
              region: 'US',
              locale: 'en_US'
            })
          }, 1000);
        }
      }
      setTimeout(function(){
        window.dispatchEvent(new Event('resize'));
      },1000);
    });

    const addToCart = (product, qty) => {
      if (process.client) {
        // @ts-ignore
        const component = Extend.buttons.instance('#extend-offer')
        const plan = component.getPlanSelection()
        const product_item = component.getActiveProduct()
        if (plan) {
          plan['product'] = product_item.id;
          product['warranty'] = plan;
          addItem({ product, quantity: parseInt(qty) })
        } else {
          const product_sku =  product.sku;
          // @ts-ignore
          Extend.modal.open({
            referenceId: product_sku,
            onClose: function(plan, product_item) {
              if (plan && product_item) {
                plan['product'] = product_item.id;
                product['warranty'] = plan;
                addItem({ product, quantity: parseInt(qty) });
              } else {
                addItem({ product, quantity: parseInt(qty) })
              }
            },
          })
        }
      }
    };

    const savingprice = (reg_p, spec_p) => {
      return reg_p - spec_p;
    };

    const string_to_json = (message) => {
      const obj = JSON.parse(message);
      return obj;
    };
    
    return {
      addToCart,
      addItem,
      addItemToWishlist: addOrRemoveItem,
      /* addItemToComparelist: addOrRemoveItemToCompare, */
      canAddToCart,
      isAuthenticated,
      isInWishlist: computed(() => isInWishlist({ product: props.product })),
      /* isInComparelist: computed(() => isInComparelist({ product: props.product })), */
      isCartLoading,
      productShortDescription,
      productGallery,
      productGallery_palceholder,
      getProductName,
      productPrice,
      productSpecialPrice,
      qty,
      imageSizes,
      setActiveTab,
      openNewReviewTab,
      activeTab,
      TabsConfig,
      addToCartError,
      savingprice,
      addedtocart_id,
      page_type,
      string_to_json,
      firstImageUrl
    };
  },
  head() {
    return {
      link: this.firstImageUrl
        ? (() => {
            // Preload the exact optimized URL Nuxt Image will render for LCP
            const optimizedHref = this.$img(this.firstImageUrl as string, { width: 500, format: 'webp' });

            return [
              {
                hid: 'first-image-preload',
                rel: 'preload',
                as: 'image',
                href: optimizedHref
              }
            ];
          })()
        : []
    };
  }
});
